import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { VenueQuery } from "../../services"
import * as model from "../../models";
import { UnsafeAction } from '../../actions/UnsafeAction';

/* tslint:disable */
@Injectable()
export class VenueActions {

	static CLEAR_STATE = "[Venue] Clear State";
	clearState(): Action {
		return {
			type: VenueActions.CLEAR_STATE
		}
	}

	static LOAD_VENUE_BY_ID = "[Venue] load Venue by ID";
	loadVenueById(venueId: number): UnsafeAction {
		return {
			type: VenueActions.LOAD_VENUE_BY_ID,
			payload: venueId
		}
	}

	static VENUE_LOADED = "[VENUE] Venue loaded";
	venueLoaded(venue: model.Venue): UnsafeAction {
		return {
			type: VenueActions.VENUE_LOADED,
			payload: venue
		}
	}

	static SEARCH_VENUES = "[Venue] search Venues";
	searchVenues(venueQuery: VenueQuery): UnsafeAction {
		return {
			type: VenueActions.SEARCH_VENUES,
			payload: venueQuery
		}
	}

	static SEARCH_VENUES_SUCCESS = "[Venues] search Venues success";
	searchVenuesSuccess(venues: model.Venue[]): UnsafeAction {
		return {
			type: VenueActions.SEARCH_VENUES_SUCCESS,
			payload: venues
		}
	}

	static SET_PAGINATION_CONFIG = "[Venues] set PaginationConfig";
	setPaginationConfig(paginationConfig): UnsafeAction {
		return {
			type: VenueActions.SET_PAGINATION_CONFIG,
			payload: paginationConfig
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/venue-components/venue.actions.ts